import React, { useEffect, useState } from 'react';
import { TableCustom, TabCustom } from '../common';
import { Box, CircularProgress } from '@material-ui/core';
import { ResponseData, PositionHead } from '../../data/ClientsData';
import '../positions/Positions.scss';
import { useHistory } from 'react-router-dom';
import { Tabs } from '../../data/ClientsData';
import { commonFn } from '../../util/commonFn';
import { clientsFindAll } from '../../redux/clients/action';
import { useDispatch, useSelector } from 'react-redux';

// Start: Main Function
export const Clients = ({ match }) => {
  const history = useHistory();

  const { clientsFindAllError, clientsFindAllData, clientsFindAllProcess } = useSelector(
    ({ clients }) => ({
      ...clients,
    }),
  );
  const { push } = useHistory();
  const dispatch = useDispatch();
  const [skip, setSkip] = useState(0);
  const limit = 10;

  // Set page title
  useEffect(() => {
    document.title = 'ATS - Clients';
  });

  useEffect(() => {
    dispatch(clientsFindAll(skip, limit));
  }, [skip]);

  // Actions click function
  const clickOnCell = (data, event) => {
    event.stopPropagation();
    const clientId = data.row[0].value;

    clientId && data?.action?.type === 'edit' && history.push(`/clients/edit/${clientId}`);
    clientId && data.action?.type === 'view' && history.push(`/clients/view/${clientId}`);
  };

  // pagination click - change page
  const pageChange = (e, value) => {
    setSkip(limit * (value - 1));
  };

  // Mapping API response
  const tableData = {
    data: clientsFindAllData?.list?.map((client) => ({
      ...client,
    })),
    head: PositionHead,
    pagination: {
      numberOfPages: clientsFindAllData?.numberOfPages,
      handleChange: pageChange,
      currentPage: skip / limit + 1,
    },
    clickOnCell: clickOnCell,
    errorMessage: clientsFindAllError?.message,
  };


  const tabs = {
    ...Tabs,
    list: commonFn.updateLink(Tabs.list, match),
  };

  return (
    <div>
      {/* Table component */}
      <TabCustom {...tabs} />

      {clientsFindAllProcess && (
        <div className="align-center mt-36">
          <CircularProgress />
        </div>
      )}

      {!clientsFindAllProcess && (
        <>
          <Box mb={4}>
            <TableCustom {...tableData} />
          </Box>
        </>
      )}
    </div>
  );
};
